import React, { forwardRef } from 'react';
import { Button, Group, Space, TextInput, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import InputMask from 'react-input-mask';
import 'react-phone-number-input/style.css'
import PhoneNumberInput from 'react-phone-number-input'
import { ConfiguredForm } from './formConfiguration';
import { useMediaQuery } from '@mantine/hooks';
import s from './AuthInformation.module.css'

type AuthInformationProps = {
  form: ConfiguredForm;
  setStep: any;
};

export const AuthInformation: React.FC<AuthInformationProps> = ({ form, setStep }) => {
  const { t } = useTranslation()
  const isDesktop = useMediaQuery('(min-width: 576px)');
  const handleSubmit = () => {
    const validationResults = form.validate();
    const fieldsWeCareAbout = ['full_name', 'phone', 'dob'];
    let canContinue = true;
    fieldsWeCareAbout.forEach(key => {
      if (validationResults.errors[key]) {
        canContinue = false;
      }
    });

    if (!canContinue) return;
    // Go to next step
    form.clearErrors();
    setStep((prev: any) => prev + 1);
  };

  const phoneInputProps = form.getInputProps('phone');
  const dobInputProps = form.getInputProps('dob');
  return (
    <>
      <Title order={3}>{t('account.subtitle')}</Title>
      <Space h={'md'} />
      <TextInput
        required
        label={t('account.inputs.name.label')}
        placeholder={t('account.inputs.name.placeholder')}
        {...form.getInputProps('full_name')}
      />
      <Space h={'md'} />

      <div className={s.phoneWrap}>
        <PhoneNumberInput
          placeholder={t('account.inputs.phone.placeholder')}
          international
          countryCallingCodeEditable={true}
          onChange={phoneInputProps.onChange}
          value={phoneInputProps.value}
          inputComponent={PhoneInput}
          error={phoneInputProps?.error}
        />
      </div>
      <Space h={'md'} />
      <InputMask mask={'99.99.9999'} onChange={dobInputProps.onChange} value={dobInputProps.value}>
        {() => {
          return (
            <TextInput
              inputMode="numeric"
              error={dobInputProps?.error}
              required
              type="text"
              label={t('account.inputs.birthday.label')}
              placeholder={t('account.inputs.birthday.placeholder')}
            />
          );
        }}
      </InputMask>
      <Group my="xl" position="right">
        <Button size="md" fullWidth={!isDesktop} color="blue" onClick={handleSubmit}>
          {t('common.buttons.next')}
        </Button>
      </Group>
    </>
  );
};

const PhoneInput = forwardRef<HTMLInputElement>((props, ref) => {
  const { t } = useTranslation()
  return (
    <TextInput
      ref={ref}
      required
      type="tel"
      label={t('account.inputs.phone.label')}
      placeholder="+7 (000) 000-00-00"
      description={t('account.inputs.phone.descriptions')}
      {...props}
    />
  )
})
